import React, { Component } from 'react';
import { GoogleMap, LoadScript, Autocomplete, Marker } from '@react-google-maps/api';
import { lte } from 'lodash';
import HttpServices from '../../utils/Http.services';
import { object, string } from 'prop-types';

const containerStyle = {
  width: '100%',
  height: '350px',
};

// const center = {
//   lat: 37.7749, // Default latitude
//   lng: -122.4194, // Default longitude
// };

class MapInput extends Component {
  state = {
    center : { lat: 1.3521, lng: 103.8198, },
    autocomplete: null,
    cities: [],
    centerMarker: {}
  }

  componentDidMount() {
    // console.log('this.props.header.information  ======>>>>>', this.props.data)
    // this.fetchCities()
    let center
    // console.log('this.props.header.information.country =>> 1', this.props.header.information.country)
    if (this.props.header.information.country) {
      console.log('this.props.header.information.country =>> 2', this.props.header.information)
      center = this.state.center
      if (this.props.header.information.country == 'sg') {
        center = { lat: 1.3521, lng: 103.8198, }
      }
      if (this.props.header.information.country == 'my') {

        center = { lat: 3.1319, lng: 101.6841 }

      }

      // this.setState({ center }, () => {
      //   // console.log('this.props.header.information.country = >> ', this.state.center)
      // })

    }
    console.log('=>>>>>>>>>>>', JSON.stringify(this.props.data))
    // if (Array.isArray(this.props.data?.coordinates) && this.props.data) {
    //   // console.log('tp111111111111111111')
    //   let coordinates = this.props.data?.coordinates
    //   // let center = this.state.centercenter
    //   let lng = coordinates[0]
    //   let lat = coordinates[1]
    //   let centerMarker = { lat, lng }
    //   this.setState({ centerMarker }, () => {
    //     if (Object.values(this.state.centerMarker).length > 0 && Object.values(this.state.centerMarker)[0] != undefined) {


    //       this.setState({ center: this.state.centerMarker }, () => {

    //         // console.log('coordinates ==>', this.state.centerMarker)
    //         // console.log('coordinates ==>', this.state.center)
    //         // console.log('cooscdvsdrdinates ==>', this.props.data?.coordinates)
    //       })
    //     }
    //   })
    // }
    // console.log('myheader', this.props.header.key)
    // if (this.props.header.key == 'mainAddress.location' || this.props.header.key == 'tempAddress.location') {
    //   // console.log('tp11111111111111111222222222221')

    //   let key = this.props.header.key
    //   let splittedKey = key.split('.')
    //   if (this.props.data && this.props.data[splittedKey[0]] && this.props.data[key] && Array.isArray(this.props.data[key]?.coordinates)) {
    //     // console.log('this.props.data[splittedKey[0]]', this.props.data[splittedKey[0]])
    //     let coordinates = this.props.data[key]?.coordinates
    //     // let center = this.state.centercenter
    //     let lng = coordinates[0]
    //     let lat = coordinates[1]
    //     let centerMarker = { lat, lng }
    //     this.setState({ centerMarker }, () => {

    //     if(Object.values(this.state.centerMarker).length >0 && Object.values(this.state.centerMarker)[0]!= undefined ){

    //       this.setState({ center: this.state.centerMarker })
    //       // console.log('coordinates ==>2', this.props.header.key, this.state.centerMarker)
    //       // console.log('cooscdvsdrdinates ==>', this.props.data?.location?.coordinates)
    //     }
    //     })
    //   }

    // } 
    // else if (this.props.header.key == 'location') {
    // console.log('tp111111111111111133333333333333333311',Object.values(this.state.centerMarker))

    // console.log('this.props.data.location 1')

    // if (this.props.data) {
    // console.log('this.props.data.location')
    // console.log('this.props.data.location', this.props.data)
    let centerMarker
    if (Array.isArray(this.props.data?.coordinates)) {
      let lng = this.props.data?.coordinates[0]
      let lat = this.props.data?.coordinates[1]
      centerMarker = { lat, lng }
    } else {
      centerMarker = this.props.data
    }

    if (!centerMarker) {
      centerMarker = {}
    }

    // // let center = this.state.centercenter
    // let lng = coordinates[0]
    // let lat = coordinates[1]
    // let centerMarker = { lat, lng }
    this.setState({ centerMarker }, () => {
      if (Object.values(this.state.centerMarker).length > 0 && Object.values(this.state.centerMarker)[0] != undefined) {
        // console.log('tp111111111111111133333333333333333311',Object.values(this.state.centerMarker))
        this.props.changeValue(this.props.header.key, this.state.centerMarker, this.props.extra)
        this.setState({ center: this.state.centerMarker ?? center })
        // console.log('coordinates ==> 2', this.props.header.key, this.state.centerMarker)
        // console.log('cooscdvsdrdinates ==>', this.props.data?.location?.coordinates)
      }else{
        this.props.changeValue(this.props.header.key, null, this.props.extra)

      }
    })
    //   }
    // }

  }
  componentDidUpdate(prev) {

    // if (prev.centerMarker != this.state.centerMarker){

    // }
    // if (this.props.data?.mainAddress?.location?.coordinates && !this.state.centerMarker) {
    //   let coordinates = this.props.data?.mainAddress.location?.coordinates
    //   // let center = this.state.centercenter
    //   console.log('coordinates mapppp ===> ', this.props.data)
    //   let lng = coordinates[0]
    //   let lat = coordinates[1]
    //   let centerMarker = { lat, lng }
    //   this.setState({ centerMarker }, () => {
    //     console.log('cooscdvsdrdinates ==>', coordinates)
    //     this.setState({ center: this.state.centerMarker })
    //     console.log('coordinates ==>', this.state.centerMarker)
    //   })
    // }

  }

  fetchAddress = () => {
    let centerMarker = this.state.centerMarker
console.log('feeeeeeeeeeeeeeeeeeeeeeeeeee',centerMarker);
    // let apiKey = ' AIzaSyDCHltxxXf8mZvNfR7GuvAhCGwaJRa93oI'
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${centerMarker?.lat},${centerMarker?.lng}&key=AIzaSyDCHltxxXf8mZvNfR7GuvAhCGwaJRa93oI`)
      .then((response) => response.json())
      .then(Address => {
        this.setState({ address: Address }, () => {

          this.handleAddressMapp()
          console.log('1address =>>>', this.state.address)
        });
      });

  }

  fetchCities = () => {
    // console.log('cities')
    let body = {}
    body.filter = {}
    body.filter.country = this.props.header.information.countryId
    // console.log('cities', body)
    HttpServices.request('getPlaces', body, (fetchResult, fetchError) => {
      if (fetchError) {
        // console.log('cities', fetchError)
        return
      }
      if (fetchResult) {
        let cities = {}
        for (let i = 0; i < fetchResult?.info.length; i++) {
          const city = fetchResult?.info[i];
          cities[city.name] = city
        }
        this.setState({ cities }, () => {
          // console.log('cities =>>> ', this.state.cities)
        })

      }
    })
  }

  handleAddressMapp = () => {
    // console.log('element =>hereeeee>',)
    let address = this.state?.address?.results[0]
    console.log('element =>hereeeee 11111>', address)
    // console.log('element =>hereeeee 11111>', /address.types["postal_code"])
    // let element = {}
    // for (let i = 0; i < address.length; i++) {
    let pIndex
    let postalCode = ''
    let city = ''
    let country = ''
    let singapore = false
    let malaysia = false


    for (let i = 0; i < address?.address_components.length; i++) {
      const element = address?.address_components[i];
      if (element.short_name == 'SG') {
        // singapore = true
        pIndex = i
        // pIndex = 'testtt'
      }
      if (element.short_name == 'MY') {
        // malaysia = true
        pIndex = i
        // pIndex = 'testtt'
      }
      // console.log('element.types ================>', element)
      if (element.types == 'postal_code') {
        // malaysia = true
        // console.log('element.types ================>', element.long_name)
        postalCode = element.long_name
        // pIndex = 'testtt'
      }
      // console.log('element =>hereeeee 11111> 2', element.types.includes('country'))
      // if ((element.short_name != 'SG' || element.short_name != 'MY') && element.types.includes('country')) {
      if (element.types.includes('country')) {
        // console.log('element =>hereeeee 11111> 3', element.types)
        pIndex = i

        country = element.long_name.toLowerCase()
        // console.log('element =>hereeeee 11111> 1', element.long_name)


      }

    }
    // console.log('cityyyyyyyy =>>>', postalCode)

    if (pIndex) {
      // console.log('cityyyyyyyy', city)
      // city = address?.address_components[pIndex - 1].long_name
      // if (city == 'Singapore') {
      //   city = this.state.cities['Singapore Mainland']?._id
      // } else if (city == 'Western Islands' || city == 'Jurong Island') {
      //   city = this.state.cities['Jurong Island']?._id


      // }

      city = address?.address_components[pIndex - 1].long_name
      // console.log('cities')
      // let body = {}
      // body.filter = {}
      // body.filter.country = this.props.header.information.countryId
      // console.log('cities', city)
      // console.log('fetchError')

      // console.log('address=>', address)
      // let mainAddress = {}

      let fulladdress = address?.formatted_address
      // let postalCode = postalCode
      let location = this.state.centerMarker

      // console.log("mainAddress adds ", mainAddress)
      // console.log("this.props.header.key", this.props.header.key)
      // return
      let keysArray = this.props.header.key.split('.')
      let mainKey = keysArray.length > 1 ? keysArray[0] : null

      // console.log()
      setTimeout(() => {
        this.props.changeValue(this.props.header.key, location, this.props.extra)

      }, 100)
      if (country.length > 0) {
        this.props.changeValue('mainAddress.country', country, this.props.extra)
        HttpServices.request('getMapCountries', { mapName: String(country) }, (fetchResult, fetchError) => {

          if (fetchError) {
            console.log('fetchError', fetchError)
            return
          }
          // let cityId 
          // console.log('cities', fetchResult)
          if (fetchResult) {

            // console.log('fetchResult.info =>>>>', fetchResult.info)
            country = fetchResult.info
            // mainAddress.city = city
            // mainAddress.address = address?.formatted_address
            // mainAddress.postalCode = postalCode
            // mainAddress.location = this.state.centerMarker

            // console.log("mainAddress adds ", mainAddress)
            // console.log("this.props.header.key", this.props.header.key)
            // return
            // let key = this.props.header.key.split('.')[0]
            // this.props.changeValue(key, mainAddress, this.props.extra)

            this.props.changeValue(('country'), country, this.props.extra)

            // mainAddress.city = city

          }
          // if(cityId){

          //   mainAddress.city = cityId
          // }else{

          // }


        })
      }
      setTimeout(() => {
        this.props.changeValue(((mainKey ? (mainKey + '.') : '') + 'postalCode'), postalCode, this.props.extra)

      }, 100);

      setTimeout(() => {
        this.props.changeValue(((mainKey ? (mainKey + '.') : '') + 'address'), fulladdress, this.props.extra)
      }, 200);
      // setTimeout(() => {
      //   this.props.changeValue(((mainKey ? (mainKey + '.') : '') + 'location'), location, this.props.extra)
      // }, 200);


      // console.log("city!!, ", city)

      if (city) {


        HttpServices.request('getMapPlaces', { mapName: String(city) }, (fetchResult, fetchError) => {

          if (fetchError) {
            console.log('fetchError', fetchError)
            return
          }
          // let cityId 
          // console.log('cities', fetchResult)
          if (fetchResult) {

            // console.log('fetchResult.info =>>>>', fetchResult.info)
            city = fetchResult.info
            // mainAddress.city = city
            // mainAddress.address = address?.formatted_address
            // mainAddress.postalCode = postalCode
            // mainAddress.location = this.state.centerMarker

            // console.log("mainAddress adds ", mainAddress)
            // console.log("this.props.header.key", this.props.header.key)
            // return
            // let key = this.props.header.key.split('.')[0]
            // this.props.changeValue(key, mainAddress, this.props.extra)

            this.props.changeValue(((mainKey ? (mainKey + '.') : '') + 'city'), city, this.props.extra)

            // mainAddress.city = city

          }
          // if(cityId){

          //   mainAddress.city = cityId
          // }else{

          // }


        })
      }
      // else {

      //   mainAddress.address = address?.formatted_address
      //   mainAddress.postalCode = postalCode
      //   mainAddress.location = this.state.centerMarker

      //   // console.log("mainAddress adds ", mainAddress)
      //   // console.log("this.props.header.key", this.props.header.key)
      //   // return
      //   let key = this.props.header.key.split('.')[0]
      //   this.props.changeValue(key, mainAddress, this.props.extra)

      // }

      // this.props.changeValue('address', address?.formatted_address)
      // this.props.changeValue('address', mainAddress)

      // this.props.changeValue('city', city)

      // setTimeout(() => {
      // this.props.changeValue('address', address?.formatted_address)
      // }, 10);
      // setTimeout(() => {
      // this.props.changeValue('postalCode', postalCode)
      // }, 10);
    }

    //  else if (pIndex && malaysia) {
    // city = address?.address_components[pIndex - 1].long_name
    // // console.log('cities')
    // // let body = {}
    // // body.filter = {}
    // // body.filter.country = this.props.header.information.countryId
    // // console.log('cities', body)
    // HttpServices.request('getMapPlaces', { mapName: city}, (fetchResult, fetchError) => {
    //   if (fetchError) {
    //     console.log('cities', fetchError)
    //     return
    //   }
    //   if (fetchResult) {
    //     city = fetchResult.info
    //   }
    // })
    // }
    // console.log('element =>hereeeee 233333>', city, postalCode)
    // this.props.handleAddress(city , address)

    // this.props.changeValue('address' , address?.formatted_address)
  }


  onLoad = (autocomplete) => {
    this.setState({ autocomplete })
    // console.log('Autocomplete is loaded:', this.state.autocomplete);
  };
  onLoadMarker = (marker) => {
    // console.log('onLoadMarker', marker)
  }
  onPlaceChanged = () => {
    if (this.state.autocomplete) {
      // console.log('Place changed:  lat ==>', this.state.autocomplete.getPlace().geometry?.location);
      let center = this.state.center
      center = this.state.autocomplete.getPlace().geometry?.location
      let centerMarker = {
        lat: this.state.autocomplete.getPlace().geometry?.location.lat(),
        lng: this.state.autocomplete.getPlace().geometry?.location.lng()
      }
      this.setState({ center, centerMarker }, () => {
        // console.log('this', this.state.center)
        this.fetchAddress()
      })
      // if (this.state.centerMarker !== null) {

      //   this.props.changeValue(this.props.header.key, this.state.centerMarker, this.props.extra)
      // }
    }
  };
  handleMapClick = (event) => {
    if (!this.props.header?.information?.diabled) {

      // console.log('event ====', event)
      let centerMarker = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      console.log('event 1', centerMarker)
      // centerMarker: { lat: event.lating.lat(),lng:event.lating.lng() }
      this.setState({ centerMarker }, () => {
        this.fetchAddress()

      })
      // if (this.state.centerMarker !== null) {
      //   this.props.changeValue(this.props.header.key, this.state.centerMarker, this.props.extra)
      // }
    }
  }
  render() {
    // console.log('this.state.center ====>', this.state.center, this.props.header.information.center)
    // let data = this.props.data
    // if (data && data.type) {
    //   data = { lat: data.coordinates[1], lng: data.coordinates[0] }
    // }
    // console.log('test address', data)
    // console.log('test address ===============', this.state.center)

    // console.log(this.props.header?.key)
    // console.log(this.props.data)

    // console.log('sssssss', this.props.data)
    // console.log('sssssss', this.props.fullData)

    let key = this.props.header.key.split('.')
    return (
      <>
        {/* {this.props.fullData[key[0]] && ( */}

        <LoadScript googleMapsApiKey="AIzaSyDCHltxxXf8mZvNfR7GuvAhCGwaJRa93oI" libraries={["places"]}>
          <GoogleMap defaultOptions={{
            scrollwheel: false,
            streetViewControl: false
          }} mapContainerStyle={containerStyle} center={this.state.center} onClick={this.handleMapClick} zoom={11.5}>
            {(!this.props.header?.information?.diabled) && (
              //  restrictions={this.props.header?.information?.notRestricted ? {} : { country: this.props.header?.information?.country }}
              <Autocomplete onLoad={this.onLoad} onPlaceChanged={this.onPlaceChanged}  restrictions={{}} options={{ strictBounds: true }}>
                <div >
                  {/* {console.log('this.props.header?.information.notRestricted', this.props.header?.information.notRestricted)} */}
                  <img src="/img/search.svg" className="equipment-img " height={18} />

                  <input style={{
                    position: 'absolute',
                    border: `1px solid transparent`,
                    width: `240px`,
                    top: `10px`,
                    left: `10px`,
                    height: `32px`,
                    padding: `0 12px`,
                    borderRadius: `3px`,
                    background: '#fff',
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `14px`,
                    outline: `none`,
                    textOverflow: `ellipses`
                  }} type="text" placeholder="Enter a location" />
                </div>
              </Autocomplete>
            )}
            <div style={{ position: 'absolute', background: 'red', width: '30px' }}>
              {/* {this.state.centerMarker && ( */}
              {/* {console.log('this.props.data==>', this.props.data)} */}
              {/* <Marker position={this.props.data ? this.props.data : this.state.centerMarker} onLoad={this.onLoadMarker} zIndex={100} /> */}
              <Marker position={this.state.centerMarker ?? this.state.center} onLoad={this.onLoadMarker} zIndex={100} />
              {/* )} */}
            </div>

          </GoogleMap>
        </LoadScript>
        {/* )} */}
      </>
    );
  }
}

export default MapInput;
